import React from 'react'
import styles from '../styles/FeatureSection.module.css'
import developmentIcon from '../../../../assets/Landing/development.png'
import marketingIcon from '../../../../assets/Landing/marketing.png'
import physicsIcon from '../../../../assets/Landing/physics.png'

const FeaturesSection = () => {
    return (
        <div className={styles.feature_section_container}>
            <div className={styles.header_wrapper}>
                {/* <h3>Features</h3> */}
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className={styles.feature_card}>
                            <div className={styles.card_cotent_wrapper}>
                                <div className={styles.icon_wrapper}>
                                    <img src={developmentIcon} alt="" />
                                </div>
                                <div className={styles.text_wrapper}>
                                    <h5>Effective Learning</h5>
                                    <p>Elmaam enables effective learning through a balanced approach—combining communication, structured training, and continuous assessment to ensure real skill development and engagement</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className={styles.feature_card}>
                            <div className={styles.card_cotent_wrapper}>
                                <div className={styles.icon_wrapper}>
                                    <img src={developmentIcon} alt="" />
                                </div>
                                <div className={styles.text_wrapper}>
                                    <h5>Reporting</h5>
                                    <p>Elmaam offers comprehensive reporting tools that give clear insights into learner progress, training effectiveness, and assessment outcomes—helping organizations make informed decisions and drive continuous improvement.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className={styles.feature_card}>
                            <div className={styles.card_cotent_wrapper}>
                                <div className={styles.icon_wrapper}>
                                    <img src={marketingIcon} alt="" />
                                </div>
                                <div className={styles.text_wrapper}>
                                    <h5>Notifications</h5>
                                    <p>Elmaam keeps users informed with timely email and mobile push notifications, ensuring they never miss important updates, training schedules, or assessment reminders.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className={styles.feature_card}>
                            <div className={styles.card_cotent_wrapper}>
                                <div className={styles.icon_wrapper}>
                                    <img src={physicsIcon} alt="" />
                                </div>
                                <div className={styles.text_wrapper}>
                                    <h5>Onboarding</h5>
                                    <p>Elmaam makes onboarding effortless—for enterprises, it's quick to set up and manage; for employees, it's simple, intuitive, and ready to go from day one.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeaturesSection